module.exports = __webpack_public_path__ + "media/images/indicators/nivelAgora-a471a48c44726c876d94e9741ddc9696.png";